module.exports = __webpack_public_path__ + "static/media/place.a93a19e7.svg";